(function() {
  'use strict';
  
  angular
    .module('plugins.free-text-response')
    .controller('FreeTextResponseResultShownController', FreeTextResponseResultShownController);
  
    FreeTextResponseResultShownController.$inject = [
    '$log', 
    '$scope',
    'pollPluginService'
  ];
    
  function FreeTextResponseResultShownController(
      $log, 
      $scope,
      pollPluginService
    ) {
    $log = $log.getInstance('FreeTextResponseResultShownController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.textResponses = []

    activate();
    
    function activate() {
      var poll = $scope.poll
        , result = $scope.result;

      // Rebuild response list and assign upvotes
      result.responses.forEach(function(response) {
        if (response.data.textResponse)
          vm.textResponses.push(response);
      })
  
      pollPluginService.onResponseReceived($scope, result._id, _onResponseReceived);
    }
    
    function _onResponseReceived(response) {
      $scope.result.responses.push(response)
      if (response.data.textResponse)
        vm.textResponses.push(response);
    }

    
  }
  
})();